import { TabsProps, useTheme } from "@mui/material"
import { useState, useEffect } from "react"
import MinimalTab from "./StyledComp/MinimalTab"
import MinimalTabs from "./StyledComp/MinimalTabs"

interface TabOption {
  value: string | number
  label?: string
  icon?: React.ReactElement<unknown, string | React.JSXElementConstructor<any>>
}

const MinimulTabs = ({
  tabs,
  value,
  gap = "8px",
  handleTabChange,
  disabledTabs = [],
  ...rest
}: {
  tabs: TabOption[]
  value: any
  gap?: string
  handleTabChange?: any
  disabledTabs?: string[]
} & TabsProps) => {
  const [tabsOrientation, setTabsOrientation] = useState<"horizontal" | "vertical" | undefined>("horizontal")
  const theme = useTheme()
  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < theme.breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal")
    }

    /** 
       The event listener that's calling the handleTabsOrientation function when resizing the window.
      */
    window.addEventListener("resize", handleTabsOrientation)

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation()

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation)
  }, [tabsOrientation])

  const handleSetTabValue = (_: any, newValue: any) => {
    handleTabChange(newValue)
  }
  return (
    <>
      {/* <Grid2 sx={{ width: "100%" }} container> */}
      {/* <Grid2 sx={{ width: "100%" }} size={{ xs: 12, sm, lg }}> */}
      <MinimalTabs orientation={tabsOrientation} value={value} onChange={handleSetTabValue} {...rest}>
        {tabs.map((tab) => {
          const isDisabled = disabledTabs?.includes(tab.value as string)
          return (
            <MinimalTab
              disabled={isDisabled}
              sx={{
                "&.MuiTab-root svg": { marginRight: gap },
                ...(isDisabled && {
                  background: (theme) => `${theme.palette.action.disabledBackground}!important`,
                  // padding: "-10px -10px",
                  borderRadius: "0px",
                  my: "-4px",
                  mr: "-4px"
                })
              }}
              value={tab.value}
              label={tab.label}
              icon={tab.icon}
            />
          )
        })}
      </MinimalTabs>
      {/* </Grid2> */}
      {/* </Grid2> */}
    </>
  )
}

export default MinimulTabs
